interface GlyphProps {
  strokeWidth?: number
}

// Spreadsheet: bordered sheet with a column/row split.
export const SheetGlyph = ({ strokeWidth = 1.6 }: GlyphProps) => (
  <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth={strokeWidth}
       strokeLinecap='round' strokeLinejoin='round' aria-hidden>
    <rect x='4' y='3' width='16' height='18' rx='2' />
    <path d='M4 10h16M11 10v11' />
  </svg>
)

// Text document: page with folded corner and text lines.
export const DocGlyph = ({ strokeWidth = 1.6 }: GlyphProps) => (
  <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth={strokeWidth}
       strokeLinecap='round' strokeLinejoin='round' aria-hidden>
    <path d='M14 3H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7Z' />
    <path d='M14 3v4h4' />
    <path d='M9 13h6M9 17h4' />
  </svg>
)
